import { Accordion, Box, Flex } from "@chakra-ui/react";
import { SupportTicket } from "models/support";
import { FC, Fragment } from "react";
import SupportTicketRow from "./SupportTicket";
import { Divider } from "antd";

// The actual list of Support Tickets
// NOTE: Because of the Suspense, this component should only ever be mounted if the data is loaded
const SupportTicketsList: FC<{
    tickets: SupportTicket[];
    unreadIds: number[] | undefined;
}> = ({ tickets, unreadIds }) => {
    const unread = unreadIds || [];

    return (
        <Box w="100%">
            {tickets.length ? (
                <Accordion allowToggle w="100%" bgColor="black">
                    {tickets?.map((ticket, i) => {
                        if (
                            i !== tickets.length - 1 &&
                            new Date(ticket.updatedAt).getFullYear() !==
                                new Date(tickets[i + 1].updatedAt).getFullYear()
                        ) {
                            return (
                                <Fragment key={ticket.id}>
                                    <SupportTicketRow
                                        ticket={ticket}
                                        unread={unread.includes(ticket.id)}
                                    />
                                    <Box bgColor="rgba(31, 41, 55, .8)">
                                        <Divider
                                            style={{
                                                margin: 0,
                                                padding: 16,
                                                borderColor: "white",
                                            }}
                                        >
                                            <Box color="white">
                                                {new Date(
                                                    tickets[i + 1].updatedAt,
                                                ).getFullYear()}
                                            </Box>
                                        </Divider>
                                    </Box>
                                </Fragment>
                            );
                        } else {
                            return (
                                <SupportTicketRow
                                    key={ticket.id}
                                    ticket={ticket}
                                    unread={unread.includes(ticket.id)}
                                />
                            );
                        }
                    })}
                </Accordion>
            ) : (
                <Flex
                    w="100%"
                    minH="15rem"
                    p={4}
                    align="center"
                    justify="center"
                >
                    No tickets to show
                </Flex>
            )}
        </Box>
    );
};

export default SupportTicketsList;
